import { jsxs as n, jsx as o } from "react/jsx-runtime";
import { c } from "./IconWinter-Cw_oV_Tf.js";
const e = c({
  displayName: "IconLogin",
  component: (a) => /* @__PURE__ */ n("svg", { focusable: "false", viewBox: "0 0 24 24", ...a, children: [
    /* @__PURE__ */ o(
      "path",
      {
        fill: "var(--nxd-icon-accent)",
        d: "M16.53 12.53a.75.75 0 0 0 0-1.06l-4-4-1.06 1.06 2.72 2.72H3v1.5h11.19l-2.72 2.72 1.06 1.06 4-4Z"
      }
    ),
    /* @__PURE__ */ o(
      "path",
      {
        fill: "var(--nxd-icon-fill)",
        d: "M8.5 4.5h11v15h-11V15H7v4.5A1.5 1.5 0 0 0 8.5 21h11a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 19.5 3h-11A1.5 1.5 0 0 0 7 4.5V9h1.5V4.5Z"
      }
    )
  ] })
});
export {
  e as I
};
//# sourceMappingURL=IconLogin-CLizFSpg.js.map
